import React from "react";
import { FaShapes } from "react-icons/fa6";
import { GrNotes } from "react-icons/gr";
import { FaRegClock } from "react-icons/fa6";
import { FaUser } from "react-icons/fa6";
import ProgressBar from 'react-bootstrap/ProgressBar';
import { useNavigate } from "react-router-dom";
import { IoMdAddCircle } from "react-icons/io";
import { FaWandMagicSparkles } from "react-icons/fa6";
import { MdOutlineSettingsSuggest } from "react-icons/md";
import {FaArrowRight } from "react-icons/fa";
import {FaArrowLeft } from "react-icons/fa";
import Form from 'react-bootstrap/Form';
import FileUpload from "../Components/FileUpload";



const Project = () => {

  const now = 50;

  const navigate = useNavigate();

  const handleFileSelect = (file) => {
    console.log("Selected file:", file);
  };

     const background ={
     background: '#EEEE',
     padding: '20px',
     paddingBottom: '50px',
   }    

   

  return (
        <>
        <div className="container mt-5">
              <div className="row top">
                    <div className="col-md-4">
                    <div className="nav-option mb-3 option1">
                      <FaShapes className="side" />
                      <p className="" onClick={() => navigate("/start-project")}>Services</p>
                    </div>
                    <div className="nav-option mb-3 option1 active text-decoration-none">
                      <GrNotes className="side" />
                      <p className="" onClick={() => navigate("/project")}>Project Details</p>
                    </div>
                    <div className="nav-option mb-3 option1">
                      <FaRegClock className="side" />
                      <p onClick={() => navigate("/timeline")}>Timeline & Budget</p>
                    </div>
                    <div className="nav-option option1">
                      <FaUser className="side" />
                      <p>Contact Info</p>
                    </div> 
                    <div className="mt-5 mb-5">
                        <h4 style={{color: '#353995', fontWeight: '700'}}>Step 1 of 4</h4>
                        <p>Let’s build  something great.</p>
                        <ProgressBar
                            now={now}
                            label={`${now}%`} 
                            variant="" 
                            >
                            <div
                                style={{
                                width: `${now}%`,
                                backgroundColor: "#F29235",
                                height: "100%",
                                transition: "width 0.6s ease"
                                }}
                            />
                        </ProgressBar>
                    </div>                       
                    </div>
                      <div className="col-md-8" style={background}>
                          <h1 style={{fontWeight: '700', lineHeight: '1.5'}}>Tell us more about your requirements</h1>
                          <p className="mt-3" style={{color: '#939394'}}>Deep dive into the specifics so we can provide a more <br /> accurate proposal and strategy</p>
                          <p style={{fontWeight: '700', color: '#939394'}}>P  R  O  J  E  C  T S  C  O  P  E</p>
                          <div className="row">
                            <div className="col-md-4 p-3">
                                <div className="p-5 text-center" style={{background: 'white', borderRadius: '20px'}}>
                                  <IoMdAddCircle className="" style={{color: '#F29235', fontSize: '40px'}} />
                                  <p style={{color: '#353995', fontWeight: '500'}}>New Project</p>
                                </div>
                            </div>
                            <div className="col-md-4 p-3">
                                <div className="p-5 text-center" style={{background: 'white', borderRadius: '20px'}}>
                                  <FaWandMagicSparkles className="align-items-center" style={{color: '#939394', fontSize: '40px'}} />
                                  <p style={{color: '#353995', fontWeight: '500'}}>Redesign</p>
                                </div>
                            </div>
                            <div className="col-md-4 p-3">
                                <div className="p-5 text-center" style={{background: 'white', borderRadius: '20px'}}>
                                  <MdOutlineSettingsSuggest className="align-items-center" style={{color: '#939394', fontSize: '40px'}} />
                                  <p style={{color: '#353995', fontWeight: '500'}}>Maintenance</p>
                                </div>
                            </div>
                          </div>
                          <div>
                            <p className="mt-5" style={{fontWeight: '700', color: '#939394'}}>P  R  I  M  A  R  Y   A  U  D  I  E  N  C  E</p>
                             <Form.Control style={{fontSize: '13px'}} size="lg" type="text" placeholder="e.g Enterprise CTOs Tech-savvy millennials , B2B Procurement Officers... " />
                          </div>
                          <div className="mt-5">
                            <p style={{fontWeight: '700', color: '#939394'}}>BRAND ASSESOR DOCUMENTATION</p>
                          </div>
                          <div className="mt-3">
                            <FileUpload onFileSelect={handleFileSelect} />
                          </div>
                          <div className="" onClick={() => navigate("/start-project")}>
                            <p style={{color: '#939394', cursor: 'pointer',}}><FaArrowLeft /> Back</p>
                          <div className="text-end mt-3">
                             <button className="step" onClick={() => navigate("/timeline")}>Next Step <FaArrowRight /></button>                             
                          </div>                            
                          </div>


                      </div>
                    </div>                
              </div>          



        </>
  );
};

export default Project;
